// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.no-scrollbar[data-v-df0b2a68]::-webkit-scrollbar {\n  display: none;\n}\n.no-scrollbar[data-v-df0b2a68] {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
